import { P0, S, abs, core, max, moodK, scaleAt, sq } from '../../geometry';

export const braces = {
  name: 'Braces',
  colors: ['#3E63DD', '#E5484D'],
  draw(m, t) {
    let gL = 0.6 * S(t * 1.6),
      gR = gL,
      hs = 1,
      pose = P0();
    if (m === 'happy') {
      gL = gR = 3 * abs(S(t * 7));
      hs = 1.05;
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the braces sway in and out in turn, stretching as they go.
    if (m === 'thinking') {
      gL = 4 * S(t * 2.6);
      gR = 4 * S(t * 2.6 + Math.PI);
      hs = 1 + 0.08 * S(t * 2.6);
    }
    if (m === 'talking') {
      gL = gR = -2 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      gL = gR = 7;
      hs = 1.15;
    }
    if (m === 'paused') {
      gL = gR = -2;
      hs = 0.8;
    }
    const shape = [
      [40, 27],
      [33, 29],
      [33, 46],
      [27, 52],
      [33, 58],
      [33, 75],
      [40, 77],
    ];
    const left = shape.map(([x, y]) => [x - gL, 52 + (y - 52) * hs]);
    const right = shape.map(([x, y]) => [100 - x + gR, 52 + (y - 52) * hs]);
    return {
      strokes: [
        { c: 'a', pts: left, n: 16 },
        { c: 'b', pts: right, n: 16 },
      ],
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.unshift(
      core(scaleAt(sq(50, 52, 12, 16, 3.4), 50, 52, moodK(m, t)))
    );
    return f;
  },
};
